// extracted by mini-css-extract-plugin
module.exports = {"label":"ShopperComment_label__eXR54","value":"ShopperComment_value__a14_0","error":"ShopperComment_error__1FFH3"};